import React, { useCallback, useRef, useState } from 'react'
import { CSVLink } from 'react-csv'
import SaveAltOutlinedIcon from '@material-ui/icons/SaveAltOutlined'

import { TableMenuButton, TablePopoverButton } from 'civic-champs-shared/core'
import { useCurrentDateWithFilename } from 'components/table/ExportCsvMenuItem'
import useExportStyles from 'export/useExportStyles'
import { Data } from 'react-csv/components/CommonPropTypes'

export const ExportButton = React.forwardRef(
  (
    props: {
      data: any[]
      disabled?: boolean
      headers: { label: string; key: string }[]
      filename: string
      formatData?: (inputData: any[]) => any[]
      type?: 'popover' | 'menu'
      children?: React.ReactNode
    },
    ref,
  ) => {
    const { data, disabled, headers, filename, formatData, type = 'menu', ...rest } = props

    const fileNameWithDate = useCurrentDateWithFilename(filename)
    const classes = useExportStyles()

    const resolvedDataRef = useRef<Data>([])
    const createFormattedData = useCallback(
      async (event, done) => {
        event.preventDefault()

        try {
          resolvedDataRef.current = await Promise.resolve(formatData ? formatData(data) : data)
          done()
        } catch (e) {
          done(false)
        }
      },
      [data, formatData],
    )

    const getData = () => resolvedDataRef.current

    const TableButtonComponent = {
      menu: TableMenuButton,
      popover: TablePopoverButton,
    }[type]

    return (
      <TableButtonComponent
        // @ts-ignore
        ref={ref}
        {...rest}
        startIcon={<SaveAltOutlinedIcon />}
        disabled={disabled || data.length === 0}
        rightMargin
      >
        <CSVLink
          style={{ textDecoration: 'none', color: disabled ? 'rgba(0, 0, 0, 0.26)' : '#0F5DB5' }}
          asyncOnClick={true}
          onClick={createFormattedData}
          className={classes.fill}
          filename={fileNameWithDate as string}
          headers={headers}
          data={getData as any}
        />
        Export
      </TableButtonComponent>
    )
  },
)

export default ExportButton
